import axios from '../../../../shared/axios';
import originAxios from 'axios';

import * as actionTypes from '../constants';

import { errorText } from '../../../../shared/constants/errorText';

const getMessagesStart = () => {
  return {
    type: actionTypes.SUPPORT_CHAT_GET_MESSAGES_START,
  };
};

const getMessagesSuccess = (data: any) => {
  return {
    type: actionTypes.SUPPORT_CHAT_GET_MESSAGES_SUCCESS,
    data,
  };
};

const getMessagesFail = (error: any) => {
  return {
    type: actionTypes.SUPPORT_CHAT_GET_MESSAGES_FAIL,
    error,
  };
};

let getMessagesCancel: any;
export const getMessages = (params: any) => {
  return (dispatch: any) => {
    return new Promise((resolve, reject) => {
      dispatch(getMessagesStart());
      const url = `/nc-roam-support-chat/get-messages`;

      if (typeof getMessagesCancel == 'function') {
        getMessagesCancel(errorText.canceledByFetchingNewData);
      }

      axios
        .get(url, {
          params: params,
          cancelToken: new originAxios.CancelToken((cancel) => {
            getMessagesCancel = cancel;
          }),
        })
        .then((response: any) => {
          dispatch(getMessagesSuccess(response.data));
          resolve(response.data);
        })
        .catch((err: any) => {
          if (originAxios.isCancel(err) && err.message === errorText.canceledByFetchingNewData) {
            resolve(err);
          } else {
            dispatch(getMessagesFail(err));
            reject(err);
          }
        });
    });
  };
};

export const setMessages = (data: any) => {
  return {
    type: actionTypes.SUPPORT_CHAT_SET_MESSAGES,
    data,
  };
};

export const setLocalMessages = (data: any) => {
  return {
    type: actionTypes.SUPPORT_CHAT_SET_LOCAL_MESSAGES,
    data,
  };
};

const getChatsStart = () => {
  return {
    type: actionTypes.SUPPORT_CHAT_GET_CHATS_START,
  };
};

const getChatsSuccess = (data: any) => {
  return {
    type: actionTypes.SUPPORT_CHAT_GET_CHATS_SUCCESS,
    data,
  };
};

const getChatsFail = (error: any) => {
  return {
    type: actionTypes.SUPPORT_CHAT_GET_CHATS_FAIL,
    error,
  };
};

let getChatsCancel: Function;
export const getChats = () => {
  return (dispatch: any) => {
    return new Promise((resolve, reject) => {
      dispatch(getChatsStart());

      const url = `/nc-roam-support-chat/get-chats`;

      if (typeof getChatsCancel == 'function') {
        getMessagesCancel(errorText.canceledByFetchingNewData);
      }

      axios
        .get(url, {
          cancelToken: new originAxios.CancelToken((cancel) => {
            getChatsCancel = cancel;
          }),
        })
        .then((response: any) => {
          dispatch(getChatsSuccess(response.data));
          resolve(response.data);
        })
        .catch((err: any) => {
          if (originAxios.isCancel(err) && err.message === errorText.canceledByFetchingNewData) {
            resolve(err);
          } else {
            dispatch(getChatsFail(err));
            reject(err);
          }
        });
    });
  };
};

export const getChatByInsuredId = (params: any) => {
  return (dispatch: any) => {
    return new Promise((resolve, reject) => {
      dispatch(getChatsStart());
      const url = `/nc-roam-support-chat/get-chat-by-insured-id`;

      axios
        .get(url, {
          params: params,
          cancelToken: new originAxios.CancelToken((cancel) => {
            getChatsCancel = cancel;
          }),
        })
        .then((response: any) => {
          dispatch(getChatsSuccess(response.data));
          resolve(response.data);
        })
        .catch((err: any) => {
          if (originAxios.isCancel(err) && err.message === errorText.canceledByFetchingNewData) {
            resolve(err);
          } else {
            dispatch(getChatsFail(err));
            reject(err);
          }
        });
    });
  };
};
